import Vue from 'vue'
import Router from 'vue-router'
import Start from './components/Startpage.vue'
import Qpage from './components/Qpage.vue'


Vue.use(Router)

export default new Router({

  base: site_url,
  routes: [
    // {
    //   path: '/',      // このパスにアクセスしたら
    //   name: 'start',
    //   component: Start // このコンポーネントを呼ぶ
    // },
    {
      path: '/',
      name: 'qpage',
      component: Qpage
    }

  ]
})
